import React, { createContext, useState } from 'react'
import { ButtonMetadata, ButtonTypes, Modal } from '@energytoolbase/components'
import { insertIf } from 'utils/arrays'
import { ButtonLabels } from 'types/modal'

export interface ConfirmMessage {
  readonly triggerConfirmMessage: (props: ConfirmMessageProps) => void
}

export interface ConfirmMessageProviderProps {
  readonly children: React.ReactNode
}

export const ConfirmMessageContext = createContext<ConfirmMessage>({
  triggerConfirmMessage: (_) => void 0
})

export interface ConfirmMessageProps {
  readonly message: string
  readonly header: string
  readonly actionButton?: ButtonMetadata
}

const emptyModal: ConfirmMessageProps = {
  header: '',
  message: ''
}

export function ConfirmMessageProvider({
  children
}: ConfirmMessageProviderProps): JSX.Element {
  const [open, setOpen] = useState(false)

  const [
    { header, message, actionButton },
    setModalContents
  ] = useState<ConfirmMessageProps>(emptyModal)

  const closeModal = (): void => {
    setOpen(false)
  }

  const triggerConfirmMessage = (
    confirmMessageProps: ConfirmMessageProps
  ): void => {
    setModalContents(confirmMessageProps)
    setOpen(true)
  }

  return (
    <ConfirmMessageContext.Provider value={{ triggerConfirmMessage }}>
      <>
        {open && (
          <Modal
            header={header}
            open={true}
            width=''
            onClose={closeModal}
            leftAlignedButtons={[
              ...insertIf(!!actionButton, {
                ...(actionButton as ButtonMetadata),
                onClick: () => {
                  closeModal()
                  actionButton?.onClick()
                }
              })
            ]}
            rightAlignedButtons={[
              {
                onClick: closeModal,
                label: ButtonLabels.Ok,
                type: ButtonTypes.BluePill
              }
            ]}
          >
            {message}
          </Modal>
        )}
        {children}
      </>
    </ConfirmMessageContext.Provider>
  )
}
